import React from "react";
import { Row, Col } from "antd";
import {
  CalendarOutlined,
  UserOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  DollarOutlined,
} from "@ant-design/icons";

export default function KpiCards({ data, onCardClick, activeKey }) {

  const present = data.attendanceSummary?.present || 0;
  const totalUsers = data.attendanceSummary?.total_users || 0;

  const onboarding =
    data.onboardings?.filter((o) => o.status !== "converted").length || 0;

  const renewals = data.expiries?.length || 0;

  const approvals = data.pendingRequests?.pending?.length || 0;

  const processed = data.payroll.data?.processed_payrolls ?? 0;
  const pending =
    Number(data.payroll.data?.pending_payrolls ?? 0) +
    Number(data.payroll.data?.no_salary_count ?? 0);
  const total = data.payroll.data?.total_employees ?? 0;

  const cards = [
    {
      title: "Attendance Overview",
      key: "clockinout",           // ← navigates to Clock In/Out tab
      value: `${present}/${totalUsers}`,
      icon: <CalendarOutlined />,
      color: "#f97316",
    },
    {
      title: "Onboarding",
      key: "onboarding",
      value: onboarding,
      icon: <UserOutlined />,
      color: "#0ea5e9",
    },
    {
      title: "Upcoming Renewals",
      key: "renewals",
      value: renewals,
      icon: <ClockCircleOutlined />,
      color: "#2563eb",
    },
    {
      title: "Pending Approvals",
      key: "pendingApproval",
      value: approvals,
      icon: <CheckCircleOutlined />,
      color: "#e11d48",
    },
    {
      title: "Processed Payroll",
      key: "processedPayroll",
      value: `${processed}/${total}`,
      icon: <DollarOutlined />,
      color: "#9333ea",
    },
    {
      title: "Pending Payroll",
      key: "pendingPayroll",
      value: `${pending}/${total}`,
      icon: <DollarOutlined />,
      color: "#16a34a",
    },
  ];

  return (
    <Row gutter={[12, 12]} className="kpi-row">
      {cards.map((card, index) => (
        <Col xs={12} sm={12} md={8} lg={8} key={index}>
          <div
            className={`kpi-widget ${activeKey === card.key ? "active" : ""}`}
            onClick={() => onCardClick?.(card.key)}
            style={{ cursor: "pointer" }}
          >
            <div className="kpi-header">
              <div className="kpi-icon" style={{ background: card.color }}>
                {card.icon}
              </div>
            </div>

            <span className="kpi-title">{card.title}</span>

            <div className="kpi-value">{card.value}</div>
          </div>
        </Col>
      ))}
    </Row>
  );
}